import React, { Component } from 'react';
import moment from 'moment';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { DisputeProgressComponent } from './DisputeProgressComponent';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import {
  DateOfBirthInput,
  GenericTextArea,
} from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import {
  DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH,
  DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH,
  MAXIMUM_DISPUTE_THRESHOLD_DAYS,
  PAGE_MAXIMUM_DISPUTE_THRESHOLD,
  PAGE_WHAT_DIDNT_YOU_RECEIVE,
  PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER,
} from '../../../constants/FraudAndDisputeConstants';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export class DescribeTheService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: FraudAndDisputeStore.getExptectedServiceStartDate(),
      descriptionText: FraudAndDisputeStore.getServiceDescriptionText(),
      validationErrorReason: null,
      startDateError: false,
      descriptionTextError: false,
      descriptionTextValidationMessage:
        props.content.serviceDescriptionTextValidationMessage,
      expectedStartDateValidationMessage:
        props.content.expectedStartDateValidationMessage,
    };
  }

  onContinueClick = () => {
    const { startDate, descriptionText } = this.state;
    const { content, setPage } = this.props;
    !startDate &&
      this.setState({
        startDateError: true,
        expectedStartDateValidationMessage:
          content.expectedStartDateValidationMessage,
      });
    (!descriptionText || (descriptionText && !descriptionText.trim().length)) &&
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.serviceDescriptionTextValidationMessage,
      });
    if (
      startDate &&
      startDate <= new Date() &&
      descriptionText &&
      descriptionText.trim().length >=
        DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.trim().length <=
        DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      /**
       * Happy path - completed validation.
       * TODOxVM Simplify this methods logic
       */

      if (moment().diff(startDate, 'day') > MAXIMUM_DISPUTE_THRESHOLD_DAYS) {
        setPage(PAGE_MAXIMUM_DISPUTE_THRESHOLD);
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_maximum_days_threshold,
          config.analytics.analytics_action_button_click
        );
        return;
      }

      this.setState({ startDateError: false, descriptionTextError: false });
      FraudAndDisputeActionCreator.setExpectedServiceStartDate(startDate);
      FraudAndDisputeActionCreator.setServiceDescriptionText(descriptionText);
      setPage(PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_describe_the_service,
        config.analytics.analytics_action_button_click
      );
      return;
    }
    if (
      descriptionText &&
      descriptionText.trim().length >=
        DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.trim().length <=
        DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: false,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length < DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.goodsDescriptionTextValidationMessage2,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length > DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.serviceDescriptionTextValidationMessage3,
      });
    }
    if (startDate && startDate <= new Date()) {
      this.setState({
        startDateError: false,
      });
    }
    if (startDate && startDate > new Date()) {
      this.setState({
        startDateError: true,
        expectedStartDateValidationMessage: content.enterCurrentDateOrEarlier,
      });
    }
  };
  render() {
    const { content, setPage } = this.props;
    const {
      startDate,
      descriptionText,
      startDateError,
      descriptionTextError,
      descriptionTextValidationMessage,
      expectedStartDateValidationMessage,
    } = this.state;
    return (
      <div>
        <ApplicationFormShell
          leftSidebar={
            <DisputeProgressComponent
              items={content.disputeProgressStepperItems}
              currentId="3"
            />
          }
        >
          <PageHeading>{content.describeTheService}</PageHeading>
          <StandardBody>
            <strong>{content.describeTheServiceSubText}</strong>
          </StandardBody>
          <div className="web-ui-components">
            <GenericFieldWrapper
              titleText={content.expectedStartDateTitleText}
              validationMessage={
                startDateError && expectedStartDateValidationMessage
              }
            >
              {/* @todo - This should be replaced once the generic DD-MM-YYYY component is available in the web ui lib */}

              <DateOfBirthInput
                id="start-date"
                onChange={(obj) =>
                  this.setState({
                    startDate: obj.value,
                  })
                }
                value={startDate}
              />
            </GenericFieldWrapper>
            <GenericFieldWrapper
              titleText={content.describeTheService}
              validationMessage={
                descriptionTextError && descriptionTextValidationMessage
              }
            >
              <GenericTextArea
                id="service-description-text"
                characterWidth={40}
                hideCharacterCount
                onChange={({ value }) => {
                  this.setState({ descriptionText: value });
                }}
                value={descriptionText}
              />
            </GenericFieldWrapper>
          </div>
          <div className="button-group">
            <NavigationButton.Secondary
              labelText={content.back}
              onClick={() => {
                setPage(PAGE_WHAT_DIDNT_YOU_RECEIVE);
              }}
            />
            <NavigationButton.Primary
              labelText={content.continueButtonText}
              onClick={this.onContinueClick}
            />
          </div>
        </ApplicationFormShell>
      </div>
    );
  }
}
